'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationActivityTracking', ['$scope', '$rootScope', function ($scope, $rootScope) {
        $scope.resetInvestigation();

        $scope.link = {
            state: 'internal.licensing.investigation.activitytrackingedit',
            params: [
                {
                    name: 'investigationActivityTrackingID',
                    field: 'id'
                },
                {
                    name: 'investigation_activity',
                    field: ''
                }
            ]
        }

        $scope.columns = [
            {
                label: 'Type',
                field: 'complaint_activity_type_name'
            },
            {
                label: 'Start Date',
                field: 'start_date',
                type: 'datetime'
            },
            {
                label: 'End Date',
                field: 'end_date',
                type: 'datetime'
            },
            {
                label: 'Note',
                field: 'note',
                type: 'ckeditor'
            },
            {
                label: 'Created On',
                field: 'createdon',
                type: 'date'
            },
            {
                label: 'Created By',
                field: 'createdby'
            }
        ];
        $scope.filters = [
            {
                name: 'Users',
                field: 'entered_by',
                options: [
                    { id: null, name: 'All Users' },
                    { id: $rootScope.userAccount.id, name: 'My Activities' }
                ],
                value: null,
                showBlank: false
            },
            {
                name: 'Date',
                field: 'createdon',
                type: 'days',
                options: [
                    { id: 0, name: 'Today' },
                    { id: 1, name: 'Yesterday' },
                    { id: 7, name: 'Last 7 Days' },
                    { id: 30, name: 'Last 30 Days' },
                    { id: 90, name: 'Last 90 Days' }
                ]
            }
        ]

    }])
;